import React, { useMemo, useEffect } from 'react';
import { connect } from 'react-redux';

import Review, { NEXT_REVIEW_AT, useNextCourseReview } from 'Containers/Review';
import { useGetFeedback } from 'Util/FeedBackService';
import { useConfig } from 'Context/ConfigContext';
import { myProfile } from 'Redux/user-profile/selectors';
import { useClassroomInterruption } from 'Util/Hooks';
import { useVideoPlayer } from 'Context/VideoPlayer';

const CourseReviewModal = ({ shouldShowReview, userId }) => {
  const { enableSkooldioCourseReview } = useConfig();

  const {
    isInterrupting,
    activateInterruption,
    deactivateInterruption,
    courseData: { courseCode, courseTitle, progressPercent },
  } = useClassroomInterruption();

  const { data: reviewData, loading: reviewLoading } = useGetFeedback({
    templateId: 'SKOOLDIO_FEEDBACK',
    contentId: courseCode,
    userId,
  });
  const { player, videoState, VIDEO_STATE } = useVideoPlayer();

  const [currentNextReviewAt, updateNextReviewAt] = useNextCourseReview({ courseCode });

  const isReviewed = useMemo(() => {
    return reviewData?.getFeedback.length !== 0;
  }, [reviewData]);

  useEffect(() => {
    const shouldShowAt80Percent =
      progressPercent >= 80 && currentNextReviewAt === NEXT_REVIEW_AT.PROGRESS_80;
    const shouldShowAt100Percent =
      progressPercent === 100 && currentNextReviewAt === NEXT_REVIEW_AT.PROGRESS_100;
    const shouldShowOnSubsectionComplete =
      shouldShowReview && (videoState === VIDEO_STATE.ENDED || player === null);

    if (
      shouldShowOnSubsectionComplete &&
      !isReviewed &&
      (shouldShowAt80Percent || shouldShowAt100Percent)
    ) {
      activateInterruption();
    }
  }, [currentNextReviewAt, isReviewed, progressPercent, shouldShowReview, videoState]);

  const handleCloseReview = () => {
    if (progressPercent === 100) {
      updateNextReviewAt(NEXT_REVIEW_AT.NONE);
    } else {
      updateNextReviewAt(NEXT_REVIEW_AT.PROGRESS_100);
    }
    deactivateInterruption();
  };

  if (!enableSkooldioCourseReview) return null;
  if (reviewLoading) return null;
  // Debugger progress percent of course
  console.debug(`Course progress is: ${progressPercent}`);
  /** Trigger course review modal if course progress more than 50% and complete section content */
  return (
    <Review
      isShow={isInterrupting}
      onCloseReview={handleCloseReview}
      courseTitle={courseTitle}
      progressPercent={progressPercent}
      revision={1}
    />
  );
};

export default connect((state) => {
  const user = myProfile(state);
  return {
    userId: user.id,
  };
}, {})(CourseReviewModal);
